import { create } from 'zustand';
import { Alumni } from '../lib/types';

interface AlumniArr {
  alumniArr: Alumni[] | [];
  setAlumniArr: (arr: Alumni[] | []) => void;
}

export const useAlumniArrStore = create<AlumniArr>()((set) => ({
  alumniArr: [],
  setAlumniArr: (arr) => set((state) => ({ alumniArr: arr })),
}));
